<template>
  <button type="button" class="btn btn-outline-primary" @click="showModal()"><font-awesome-icon icon="file-import" /> Benutzer importieren</button>

  <!-- Import Benutzer Modal -->
  <div class="modal fade" id="importUserModal" tabindex="-1" aria-labelledby="importUserModalLabel" aria-hidden="true" ref="importUserModalRef">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary py-2" data-bs-theme="dark">
          <span class="modal-title my-auto text-white" id="importUserModalLabel">Archiv Benutzer Importieren</span>

          <button type="button" class="btn-close btn-sm" @click="closeModal()"></button>
        </div>

        <div class="modal-body" id="importUserModalBody">
          <div class="alert alert-danger my-3" v-if="!loading && errorMsg">{{ errorMsg }}</div>

          <LoadingSpinner v-if="loading" />

          <div v-else>
            <div v-for="archivUser in archivUsers" :key="archivUser.id">
              <ArchivUserRow
                :archivUser="archivUser"
                :user="getUser(archivUser.guid)"
                :mergeUser="getMergeUser(archivUser.email)"
                :conflictUser="getConflictUser(archivUser)"
                :unternehmen="props.unternehmen"
                :realm="props.unternehmen.realm"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, computed, ref } from 'vue';
  import { Modal } from 'bootstrap';
  import { useUnternehmenStore } from '@/stores/unternehmenStore';
  // import { useBenutzerStore } from '@/stores/benutzerStore';
  import { useCommonStore } from '@/stores/commonStore';

  // import { User } from '@/models/BenutzerModels';
  import { Unternehmen } from '@/models/UnternehmenModels';

  import ArchivUserRow from './ArchivUserRow.vue';
  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  import { User } from '@/models/BenutzerModels';
  //#endregion

  const props = defineProps({
    unternehmen: {
      type: Object as PropType<Unternehmen>,
      required: true,
    },
  });

  const emits = defineEmits(['importedBenutzer']);

  // const benutzerStore = useBenutzerStore();
  const unternehmenStore = useUnternehmenStore();
  const commonStore = useCommonStore();

  const loading = computed(() => commonStore.status.getUnternehmenUsersLoading || commonStore.status.getAllArchivUserLoading);
  const errorMsg = computed(() => commonStore.status.archivUserErrorMsg);

  const users = computed(() => unternehmenStore.users);
  const archivUsers = computed(() => unternehmenStore.archivUsers);

  function getUser(id: string) {
    if (id == '' || id == undefined || users.value == undefined) {
      return undefined;
    }

    return users.value.find((u: User) => u.id === id);
  }

  function getMergeUser(email: string) {
    if (email == '' || email == undefined || users.value == undefined) {
      return undefined;
    }

    return users.value.find((u: User) => u.email === email);
  }

  function getConflictUser(archivUser: any) {
    if (archivUser.email == undefined || archivUser.email.trim() == '' || users.value == undefined) {
      return undefined;
    }

    const keylcloakEmailUser = users.value.find((u: User) => u.email === archivUser.email);

    if (keylcloakEmailUser != undefined) {
      return archivUsers.value.find((au: any) => au.guid === keylcloakEmailUser.id);
    }

    return undefined;
  }

  //#region Modal
  const importUserModalRef = ref();

  function closeModal() {
    Modal.getInstance(importUserModalRef.value)?.hide();
  }

  async function showModal() {
    if (importUserModalRef.value) {
      new Modal(importUserModalRef.value).show();
      await unternehmenStore.getUnternehmenArchivUsers(props.unternehmen.id);
    }
  }
  //#endregion
</script>

<style scoped>
  .modal-content {
    background: rgb(242, 243, 248);
  }

  /* .modal-body {
  background: rgb(242, 243, 248);
}

.modal-footer {
  background: rgb(242, 243, 248);
} */
</style>
